module.exports = __webpack_public_path__ + "img/banner4.806c2166.png";